import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=f798eb8c&scoped=true"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"
import style0 from "./_faq.css?vue&type=style&index=0&id=f798eb8c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f798eb8c",
  null
  
)

export default component.exports